module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "sidebar",
    attrs: {
      "data-color": "purple",
      "data-image": "assets/img/sidebar-5.jpg"
    }
  }, [_c('div', {
    staticClass: "sidebar-wrapper"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('a', {
    staticClass: "simple-text",
    attrs: {
      "href": "http://www.creative-tim.com"
    }
  }, [_vm._v("\n                    Creative " + _vm._s(_vm.myname) + "\n                ")])]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "dashboard.html"
    }
  }, [_c('i', {
    staticClass: "pe-7s-graph"
  }), _vm._v(" "), _c('p', [_vm._v("Dashboard")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "user.html"
    }
  }, [_c('i', {
    staticClass: "pe-7s-user"
  }), _vm._v(" "), _c('p', [_vm._v("User Profile")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "table.html"
    }
  }, [_c('i', {
    staticClass: "pe-7s-note2"
  }), _vm._v(" "), _c('p', [_vm._v("Table List")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "typography.html"
    }
  }, [_c('i', {
    staticClass: "pe-7s-news-paper"
  }), _vm._v(" "), _c('p', [_vm._v("Typography")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "icons.html"
    }
  }, [_c('i', {
    staticClass: "pe-7s-science"
  }), _vm._v(" "), _c('p', [_vm._v("Icons")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "maps.html"
    }
  }, [_c('i', {
    staticClass: "pe-7s-map-marker"
  }), _vm._v(" "), _c('p', [_vm._v("Maps")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "notifications.html"
    }
  }, [_c('i', {
    staticClass: "pe-7s-bell"
  }), _vm._v(" "), _c('p', [_vm._v("Notifications")])])]), _vm._v(" "), _c('li', {
    staticClass: "active-pro"
  }, [_c('a', {
    attrs: {
      "href": "upgrade.html"
    }
  }, [_c('i', {
    staticClass: "pe-7s-rocket"
  }), _vm._v(" "), _c('p', [_vm._v("Upgrade to PRO")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-panel"
  }, [_c('nav', {
    staticClass: "navbar navbar-default navbar-fixed"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navigation-example-2"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Dashboard")])]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse"
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-left"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" "), _c('p', {
    staticClass: "hidden-lg hidden-md"
  }, [_vm._v("Dashboard")])])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" "), _c('b', {
    staticClass: "caret hidden-lg hidden-md"
  }), _vm._v(" "), _c('p', {
    staticClass: "hidden-lg hidden-md"
  }, [_vm._v("\n                                        5 Notifications\n                                        "), _c('b', {
    staticClass: "caret"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Notification 1")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Notification 2")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Notification 3")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Notification 4")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Another notification")])])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" "), _c('p', {
    staticClass: "hidden-lg hidden-md"
  }, [_vm._v("Search")])])])]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('p', [_vm._v("Account")])])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('p', [_vm._v("\n                                        Dropdown\n                                        "), _c('b', {
    staticClass: "caret"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Something")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Something")])]), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Separated link")])])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('p', [_vm._v("Log out")])])]), _vm._v(" "), _c('li', {
    staticClass: "separator hidden-lg"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Email Statistics")]), _vm._v(" "), _c('p', {
    staticClass: "category"
  }, [_vm._v("Last Campaign Performance")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "ct-chart ct-perfect-fourth",
    attrs: {
      "id": "chartPreferences"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "legend"
  }, [_c('i', {
    staticClass: "fa fa-circle text-info"
  }), _vm._v(" Open\n                                        "), _c('i', {
    staticClass: "fa fa-circle text-danger"
  }), _vm._v(" Bounce\n                                        "), _c('i', {
    staticClass: "fa fa-circle text-warning"
  }), _vm._v(" Unsubscribe\n                                    ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "stats"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Campaign sent 2 days ago\n                                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Users Behavior")]), _vm._v(" "), _c('p', {
    staticClass: "category"
  }, [_vm._v("24 Hours performance")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "ct-chart",
    attrs: {
      "id": "chartHours"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "legend"
  }, [_c('i', {
    staticClass: "fa fa-circle text-info"
  }), _vm._v(" Open\n                                        "), _c('i', {
    staticClass: "fa fa-circle text-danger"
  }), _vm._v(" Click\n                                        "), _c('i', {
    staticClass: "fa fa-circle text-warning"
  }), _vm._v(" Click Second Time\n                                    ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "stats"
  }, [_c('i', {
    staticClass: "fa fa-history"
  }), _vm._v(" Updated 3 minutes ago\n                                    ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card "
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("2014 Sales")]), _vm._v(" "), _c('p', {
    staticClass: "category"
  }, [_vm._v("All products including Taxes")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "ct-chart",
    attrs: {
      "id": "chartActivity"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "legend"
  }, [_c('i', {
    staticClass: "fa fa-circle text-info"
  }), _vm._v(" Tesla Model S\n                                        "), _c('i', {
    staticClass: "fa fa-circle text-danger"
  }), _vm._v(" BMW 5 Series\n                                    ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "stats"
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Data information certified\n                                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card "
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Tasks")]), _vm._v(" "), _c('p', {
    staticClass: "category"
  }, [_vm._v("Backend development")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "table-full-width"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', [_c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    attrs: {
      "id": "checkbox1",
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox1"
    }
  })])]), _vm._v(" "), _c('td', [_vm._v("Sign contract for \"What are conference organizers afraid of?\"")]), _vm._v(" "), _c('td', {
    staticClass: "td-actions text-right"
  }, [_c('button', {
    staticClass: "btn btn-info btn-simple btn-xs",
    attrs: {
      "type": "button",
      "rel": "tooltip",
      "title": "Edit Task"
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-simple btn-xs",
    attrs: {
      "type": "button",
      "rel": "tooltip",
      "title": "Remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    attrs: {
      "id": "checkbox2",
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox2"
    }
  })])]), _vm._v(" "), _c('td', [_vm._v("Lines From Great Russian Literature? Or E-mails From My Boss?")]), _vm._v(" "), _c('td', {
    staticClass: "td-actions text-right"
  }, [_c('button', {
    staticClass: "btn btn-info btn-simple btn-xs",
    attrs: {
      "type": "button",
      "rel": "tooltip",
      "title": "Edit Task"
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-simple btn-xs",
    attrs: {
      "type": "button",
      "rel": "tooltip",
      "title": "Remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    attrs: {
      "id": "checkbox3",
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox3"
    }
  })])]), _vm._v(" "), _c('td', [_vm._v("Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit\n                                                ")]), _vm._v(" "), _c('td', {
    staticClass: "td-actions text-right"
  }, [_c('button', {
    staticClass: "btn btn-info btn-simple btn-xs",
    attrs: {
      "type": "button",
      "rel": "tooltip",
      "title": "Edit Task"
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-simple btn-xs",
    attrs: {
      "type": "button",
      "rel": "tooltip",
      "title": "Remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    attrs: {
      "id": "checkbox4",
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox4"
    }
  })])]), _vm._v(" "), _c('td', [_vm._v("Create 4 Invisible User Experiences you Never Knew About")]), _vm._v(" "), _c('td', {
    staticClass: "td-actions text-right"
  }, [_c('button', {
    staticClass: "btn btn-info btn-simple btn-xs",
    attrs: {
      "type": "button",
      "rel": "tooltip",
      "title": "Edit Task"
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-simple btn-xs",
    attrs: {
      "type": "button",
      "rel": "tooltip",
      "title": "Remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    attrs: {
      "id": "checkbox5",
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox5"
    }
  })])]), _vm._v(" "), _c('td', [_vm._v("Read \"Following makes Medium better\"")]), _vm._v(" "), _c('td', {
    staticClass: "td-actions text-right"
  }, [_c('button', {
    staticClass: "btn btn-info btn-simple btn-xs",
    attrs: {
      "type": "button",
      "rel": "tooltip",
      "title": "Edit Task"
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-simple btn-xs",
    attrs: {
      "type": "button",
      "rel": "tooltip",
      "title": "Remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    attrs: {
      "id": "checkbox6",
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox6"
    }
  })])]), _vm._v(" "), _c('td', [_vm._v("Unfollow 5 enemies from twitter")]), _vm._v(" "), _c('td', {
    staticClass: "td-actions text-right"
  }, [_c('button', {
    staticClass: "btn btn-info btn-simple btn-xs",
    attrs: {
      "type": "button",
      "rel": "tooltip",
      "title": "Edit Task"
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-simple btn-xs",
    attrs: {
      "type": "button",
      "rel": "tooltip",
      "title": "Remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "stats"
  }, [_c('i', {
    staticClass: "fa fa-history"
  }), _vm._v(" Updated 3 minutes ago\n                                    ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "toolbar"
  }), _vm._v(" "), _c('div', {
    staticClass: "fresh-datatables"
  }, [_c('table', {
    staticClass: "table table-striped table-no-bordered table-hover",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "datatables",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Position")]), _vm._v(" "), _c('th', [_vm._v("Office")]), _vm._v(" "), _c('th', [_vm._v("Age")]), _vm._v(" "), _c('th', [_vm._v("Start date")]), _vm._v(" "), _c('th', {
    staticClass: "disabled-sorting text-right"
  }, [_vm._v("Actions")])])]), _vm._v(" "), _c('tfoot', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Position")]), _vm._v(" "), _c('th', [_vm._v("Office")]), _vm._v(" "), _c('th', [_vm._v("Age")]), _vm._v(" "), _c('th', [_vm._v("Start date")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Tiger Nixon")]), _vm._v(" "), _c('td', [_vm._v("System Architect")]), _vm._v(" "), _c('td', [_vm._v("Edinburgh")]), _vm._v(" "), _c('td', [_vm._v("61")]), _vm._v(" "), _c('td', [_vm._v("2011/04/25")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-simple btn-info btn-icon like",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-heart"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-simple btn-warning btn-icon edit",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-simple btn-danger btn-icon remove",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Garrett Winters")]), _vm._v(" "), _c('td', [_vm._v("Accountant")]), _vm._v(" "), _c('td', [_vm._v("Tokyo")]), _vm._v(" "), _c('td', [_vm._v("63")]), _vm._v(" "), _c('td', [_vm._v("2011/07/25")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-simple btn-info btn-icon like",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-heart"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-simple btn-warning btn-icon edit",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-simple btn-danger btn-icon remove",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Ashton Cox")]), _vm._v(" "), _c('td', [_vm._v("Junior Technical Author")]), _vm._v(" "), _c('td', [_vm._v("San Francisco")]), _vm._v(" "), _c('td', [_vm._v("66")]), _vm._v(" "), _c('td', [_vm._v("2009/01/12")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-simple btn-info btn-icon like",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-heart"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-simple btn-warning btn-icon edit",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-simple btn-danger btn-icon remove",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Cedric Kelly")]), _vm._v(" "), _c('td', [_vm._v("Senior Javascript Developer")]), _vm._v(" "), _c('td', [_vm._v("Edinburgh")]), _vm._v(" "), _c('td', [_vm._v("22")]), _vm._v(" "), _c('td', [_vm._v("2012/03/29")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-simple btn-info btn-icon like",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-heart"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-simple btn-warning btn-icon edit",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-simple btn-danger btn-icon remove",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Airi Satou")]), _vm._v(" "), _c('td', [_vm._v("Accountant")]), _vm._v(" "), _c('td', [_vm._v("Tokyo")]), _vm._v(" "), _c('td', [_vm._v("33")]), _vm._v(" "), _c('td', [_vm._v("2008/11/28")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-simple btn-info btn-icon like",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-heart"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-simple btn-warning btn-icon edit",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-simple btn-danger btn-icon remove",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])])])])])])])])])])]), _vm._v(" "), _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('nav', {
    staticClass: "pull-left"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                                Home\n                            ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                                Company\n                            ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                                Portfolio\n                            ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                               Blog\n                            ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copyright pull-right"
  }, [_vm._v("\n                    © 2018 "), _c('a', {
    attrs: {
      "href": "http://www.creative-tim.com"
    }
  }, [_vm._v("Creative Tim")]), _vm._v(", made with love for a better web\n                ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f9e0239"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/demo.vue
// module id = 694
// module chunks = 0